import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import PageHome from "containers/PageHome/PageHome";
import Page404 from "containers/Page404/Page404";
import ListingStayPage from "containers/ListingStayPage/ListingStayPage";
import ListingStayMapPage from "containers/ListingStayPage/ListingStayMapPage";
import ListingExperiencesPage from "containers/ListingExperiencesPage/ListingExperiencesPage";
import ListingExperiencesMapPage from "containers/ListingExperiencesPage/ListingExperiencesMapPage";
import ListingCarPage from "containers/ListingCarPage/ListingCarPage";
import ListingCarMapPage from "containers/ListingCarPage/ListingCarMapPage";
import CheckOutPage from "containers/CheckOutPage/CheckOutPage";
import PayPage from "containers/PayPage/PayPage";
import AuthorPage from "../containers/AuthorPage/AuthorPage";
import AccountPage from "containers/AccountPage/AccountPage";
import AccountPass from "containers/AccountPage/AccountPass";
import AccountSavelists from "containers/AccountPage/AccountSavelists";
import AccountBilling from "containers/AccountPage/AccountBilling";
import PageContact from "containers/PageContact/PageContact";
import PageAbout from "containers/PageAbout/PageAbout";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageLogin from "containers/PageLogin/PageLogin";
import PageSubcription from "containers/PageSubcription/PageSubcription";
import BlogPage from "containers/BlogPage/BlogPage";
import BlogSingle from "containers/BlogPage/BlogSingle";
import PageAddListing1 from "containers/PageAddListing1/PageAddListing1";
import PageAddListing2 from "containers/PageAddListing1/PageAddListing2";
import PageAddListing3 from "containers/PageAddListing1/PageAddListing3";
import PageAddListing4 from "containers/PageAddListing1/PageAddListing4";
import PageAddListing5 from "containers/PageAddListing1/PageAddListing5";
import PageAddListing6 from "containers/PageAddListing1/PageAddListing6";
import PageAddListing7 from "containers/PageAddListing1/PageAddListing7";
import PageAddListing8 from "containers/PageAddListing1/PageAddListing8";
import PageAddListing9 from "containers/PageAddListing1/PageAddListing9";
import PageAddListing10 from "containers/PageAddListing1/PageAddListing10";
import Menu from "containers/Menu/Menu";
import PageHome2 from "containers/PageHome/PageHome2";
import ListingRealEstateMapPage from "containers/ListingRealEstatePage/ListingRealEstateMapPage";
import ListingRealEstatePage from "containers/ListingRealEstatePage/ListingRealEstatePage";
import SiteHeader from "containers/SiteHeader";
import ListingFlightsPage from "containers/ListingFlightsPage/ListingFlightsPage";
import FooterNav from "components/FooterNav";
import useWindowSize from "hooks/useWindowResize";
import PageHome3 from "containers/PageHome/PageHome3";
import ListingStayDetailPage from "containers/ListingDetailPage/listing-stay-detail/ListingStayDetailPage";
import ListingCarDetailPage from "containers/ListingDetailPage/listing-car-detail/ListingCarDetailPage";
import ListingExperiencesDetailPage from "containers/ListingDetailPage/listing-experiences-detail/ListingExperiencesDetailPage";
import Royalty from "containers/Royalty/Royalty";
import UserInbox from "containers/UserInbox/UserInbox";
import Qrcode from "containers/QR-Code/Qrcode";
import AuthModal from "components/AuthModal/AuthModal";
import { ToastContainer } from "react-toastify";
import CartMenu from "containers/CartPage/CartMenu";
import ProtectedPage from "containers/ProtectPage/ProtectedPage";
import MenuCheckOutPagePageMain from "containers/CheckOutPage/MenuCheckOut/MenuCheckOutPage";
import GooeyMenu from "components/gooeymenu/GooeyMenu";
import FloatingNav from "shared/FloatingNav/FloatingNave";
import Dashboard from "containers/UserDashboard/Dashboard";
import VerifyEmailPage from "components/AuthModal/VerifyEmailForm";
import ResetPasswordForm from "components/AuthModal/ResetPassword";
import CheckOutProcess from "containers/CheckOutProcess/CheckOutProcess";
import SectionExpiredModal from "components/SectionExpiredModal/SectionExpiredModal";
import { useDispatch } from "react-redux";
import { setExpiredModalOpen } from "../redux/features/expiredModalSlice";
import ListingBooking from "containers/ListingBooking/ListingBooking";
import ListingOrders from "containers/ListingOrders/ListingOrders";
import LoyaltyWallet from "containers/Loyalty/LoyaltyWallet";
import LoyaltyCardDetail from "containers/Loyalty/LoyaltyCardDetail";
import LoyaltyWallets from "containers/LoyaltyWallet/LoyaltyWallets";
import LoyaltyCardDetails from "containers/LoyaltyWallet/LoyaltyCardDetail";
import WillominaPage from "containers/AuthorPage/WillominaPage";
import BookingMain from "containers/Booking/BookingMain";
import CartBooking from "containers/CartBooking/CartBooking";
import BookingDetailMainPage from "containers/ListingBooking/BookingDetailPage/BooKingDetailPage";

export const pages: Page[] = [
  { path: "/home-1-header-2", exact: true, component: PageHome },
  { path: "/home-2", component: PageHome2 },
  { path: "/home-3", component: PageHome3 },
  //
  { path: "/listing-stay", component: ListingStayPage },
  { path: "/listing-stay-map", component: ListingStayMapPage },
  { path: "/listing-stay-detail", component: ListingStayDetailPage },
  //
  {
    path: "/listing-experiences",
    component: ListingExperiencesPage,
  },
  {
    path: "/listing-experiences-map",
    component: ListingExperiencesMapPage,
  },
  {
    path: "/listing-experiences-detail",
    component: ListingExperiencesDetailPage,
  },
  //
  { path: "/listing-car", component: ListingCarPage },
  { path: "/listing-car-map", component: ListingCarMapPage },
  { path: "/listing-car-detail", component: ListingCarDetailPage },
  //
  { path: "/listing-real-estate-map", component: ListingRealEstateMapPage },
  { path: "/listing-real-estate", component: ListingRealEstatePage },
  //
  { path: "/listing-flights", component: ListingFlightsPage },
  //
  { path: "/checkout", component: CheckOutPage },
  { path: "/checkoutprocess", component: CheckOutProcess },

  { path: "/pay-done", component: PayPage },

  //
  { path: "/blog", component: BlogPage },
  { path: "/blog-single", component: BlogSingle },
  //
  { path: "/add-listing-1", component: PageAddListing1 },
  { path: "/add-listing-2", component: PageAddListing2 },
  { path: "/add-listing-3", component: PageAddListing3 },
  { path: "/add-listing-4", component: PageAddListing4 },
  { path: "/add-listing-5", component: PageAddListing5 },
  { path: "/add-listing-6", component: PageAddListing6 },
  { path: "/add-listing-7", component: PageAddListing7 },
  { path: "/add-listing-8", component: PageAddListing8 },
  { path: "/add-listing-9", component: PageAddListing9 },
  { path: "/add-listing-10", component: PageAddListing10 },
  //
  //operator
  { path: "/operator", component: AuthorPage },

  //user dashboard
  { path: "/dashboard", component: Dashboard },
  { path: "/booking", component: ListingBooking },
  { path: "/bookings/:bookingId", component: BookingDetailMainPage },

  { path: "/orders", component: ListingOrders },
  { path: "/orders/:orderId", component: MenuCheckOutPagePageMain },

  { path: "/loyalty", component: Royalty },
  { path: "/loyaltywallet", component: LoyaltyWallet },
  { path: "/loyaltywallet/:id", component: LoyaltyCardDetail },

  // real loyalty wallets

  { path: "/loyaltywallets", component: LoyaltyWallets },
  { path: "/loyaltywallets/:id", component: LoyaltyCardDetails },

  { path: "/account", component: AccountPage },
  { path: "/account-password", component: AccountPass },
  { path: "/account-savelists", component: AccountSavelists },
  { path: "/account-billing", component: AccountBilling },

  { path: "/contact", component: PageContact },
  { path: "/about", component: PageAbout },
  { path: "/signup", component: PageSignUp },
  { path: "/login", component: PageLogin },
  { path: "/subscription", component: PageSubcription },
  { path: "/operator/menu/:slug", component: Menu },
  { path: "/operator/booking/:slug", component: BookingMain },

  { path: "/userInbox", component: UserInbox },
  //
  { path: "/qr-code", component: Qrcode },
  { path: "/verify-email", component: VerifyEmailPage },
  { path: "/reset-password/:token", component: ResetPasswordForm },
  { path: "/willomina", component: WillominaPage },
];

const MyRoutes = ({ socketId }: { socketId: any }) => {
  let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }

  // Enable dark mode by default
  const root = document.documentElement;
  if (!root.classList.contains("dark")) {
    root.classList.add("dark");
  }
  localStorage.theme = "dark";

  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(setExpiredModalOpen(true));
  // }, [dispatch]);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <SiteHeader />
      <AuthModal />
      <SectionExpiredModal />
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
      />
      <Routes>
        <Route path="/" element={<PageHome3 />} />
        <Route path="#" element={<PageHome3 />} />
        <Route
          path="/author/:slug"
          element={
            <ProtectedPage>
              <AuthorPage />
            </ProtectedPage>
          }
        />

        <Route
          path="checkout/order/:orderId"
          element={
            <ProtectedPage>
              <MenuCheckOutPagePageMain />
            </ProtectedPage>
          }
        />

        {pages.map(({ component, path }) => {
          const Component = component;
          return (
            <Route
              key={path}
              path={path}
              element={
                path === "/userInbox" ? (
                  <Component socketId={socketId} />
                ) : (
                  <Component />
                )
              }
            />
          );
        })}

        <Route path="*" element={<Page404 />} />
      </Routes>

      {/* order cart */}
      <CartMenu />

      {/* booking cart */}
      <CartBooking />
      {/* {WIN_WIDTH < 768 && window.location.pathname !== "/checkoutprocess" && (
        <FooterNav />
      )} */}
      {/* <GooeyMenu /> */}
      {/* {WIN_WIDTH < 768 && <FloatingNav />} */}

      <div
        className={`${
          window.location.pathname === "/checkoutprocess"
            ? "hidden md:block"
            : "block"
        }`}
      >
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default MyRoutes;
